import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Info } from "lucide-react";

export const InfoTip = ({ text }) => (
  <TooltipProvider delayDuration={200}>
    <Tooltip>
      <TooltipTrigger asChild>
        <Info className="w-3 h-3 text-muted-foreground/50 hover:text-muted-foreground cursor-help transition-colors inline-block ml-1" data-testid="info-tip" />
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs text-[11px] leading-relaxed bg-popover text-popover-foreground border border-border shadow-lg">
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
